import { render } from "./Zonamodal.vue?vue&type=template&id=42809bfc"
import script from "./Zonamodal.vue?vue&type=script&lang=js"
export * from "./Zonamodal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__